<template>
	<!--Words -->
	<div class="landing-solutions">
		<section class="content-solution-landing" v-in-viewport="">
			<div class="inside">
				<div class="text-center headline-container" v-if="pageSolution.header_text">
			  	 	<h1 class="headline" v-in-viewport="">{{pageSolution.header_text.value}}</h1>
						<p class="intro_text" v-in-viewport="{}" v-if="pageSolution.intro_paragraph">{{pageSolution.intro_paragraph.value}}</p>
			 	</div>

			 	<articles-wrapper :boxes="solutions" :modularContent="modularContent" :isHome="false" :boxlimit="1000" :pathRoute="'/solutions'" :showCategory="false"></articles-wrapper>
			</div>
		</section>
	</div>
</template>

<script>
	import apiConnection from '../mixins/apiConnection.js';
	import seoModule from '../mixins/seoModule.js';
	import articlesSolutions from '../components/articles-solutions.vue';

	export default{
		name: 'Solutions',

		data(){
			return{
				pageSolution:[],
				solutions:[],
				modularContent:[]
			}
		},
		components:{
			'articles-wrapper':articlesSolutions
		},
		created(){
			this.getSolutions(1000);
			this.getSolution(true);			
		},
		mounted: function() {
			setTimeout(function(){
			    $('.st-sticky-share-buttons').removeClass('st-sticky-share-buttons-show')
			},500);

		},
		mixins:[apiConnection,seoModule]
	}
</script>



// WEBPACK FOOTER //
// Solutions.vue?9edb0cfe